import React, { Component } from 'react'
import {
    Link
} from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx"
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import { Features, AccountFeatures } from "@lightspeed-invoicing/core-client/frontend";
import GlobalHelper from "../../common/GlobalHelper.jsx";
import { getPriceListName } from "../../name-helpers/priceListNameHelper";
import LinkTemplateWrapper from '../../common/rich-text/feature-protection-wrappers/linkTemplateWrapper.component';

class EmailTemplatesSection extends Component {


    getLinks() {
        return ([
            {
                name: "quotes",
                to: "/settings/email-templates/send-proposal/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.email.template.send_proposal_template_name"
                    defaultMessage="Send quote template"
                />
            },
            {
                name: "contracts",
                to: "/settings/email-templates/send-contract/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.email.template.send_contract_name"
                    defaultMessage="Send contract template"
                />,
            },
            {
                name: "orders",
                to: "/settings/email-templates/send-order/listing",
                module: AccountFeatures.FeatureOrder,
                message: <FormattedMessage
                    id="settings.email.template.send_order_name"
                    defaultMessage="Send order template"
                />
            },
            {
                name: "invoices",
                to: "/settings/email-templates/send-invoice/listing",
                module: Features.Invoice,
                message: <FormattedMessage
                    id="settings.email.template.send_invoice_name"
                    defaultMessage="Send invoice template"
                />
            },
            {
                name: "price-lists",
                to: "/settings/email-templates/new-order-from-price-list/listing",
                module: AccountFeatures.FeaturePriceList,
                message: <FormattedMessage
                    id="settings.email.template.new_order_from_price_list"
                    defaultMessage="New order from {priceList} template"
                    values={{
                        priceList: getPriceListName(this.props.intl)
                    }}
                />
            },
            {
                name: "credit-memos",
                to: "/settings/editEmailTemplates/send-credit-memo",
                module: "",
                message: <FormattedMessage
                    id="settings.email.template.send_credit_memo_receipt_template_name"
                    defaultMessage="Send credit memo receipt template"
                />
            },
            {
                name: "account-statements",
                to: "/settings/editEmailTemplates/send-account-statement",
                module: AccountFeatures.FeatureAccountStatements,
                message: <FormattedMessage
                    id="settings.email.template.send_customer_statement_name"
                    defaultMessage="Send account statement template"
                />
            },
            {
                name: "scheduling-pages",
                to: "/settings/email-templates/send-scheduling-page/listing",
                module: AccountFeatures.FeatureScheduling,
                message: <FormattedMessage
                    id="settings.email.template.send_scheduling_page_name"
                    defaultMessage="Send scheduling page template"
                />
            },

            {
                name: "events",
                to: "/settings/email-templates/send-booking-confirmation/listing",
                module: AccountFeatures.FeatureScheduling,
                message: <FormattedMessage
                    id="settings.email.template.send_booking_confirmation_name"
                    defaultMessage="Send booking confirmation template"
                />
            }
        ])
    }

    render() {
        const supportedDocuments = GlobalHelper.getSupportedDocuments()
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.email.template.title'
                                        defaultMessage='Email templates'
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="row" style={{ paddingLeft: "20px" }}>
                            <div className="col-12 list-group">

                                {this.getLinks().filter(l => supportedDocuments.includes(l.name)).map((elem, index) => {
                                    return (
                                        <LinkTemplateWrapper
                                            key={index}
                                            module={elem.module}
                                            to={elem.to}
                                            redirectToAccount={true}
                                            className={"list-group-item"}
                                            protectedClassName={"list-group-item"}
                                            premium={false}
                                            protectionRule={elem.module === "" ? true : AppContext.accountFeatureIsEnabled(elem.module)}
                                        >
                                            <Icon value={"envelope"} className={'mr-1'} />
                                            {elem.message}
                                            <Icon value={"chevron-right"} />
                                        </LinkTemplateWrapper>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(EmailTemplatesSection)


// WEBPACK FOOTER //
// ./src/settings/emails/section.component.jsx